export * from './customer.service';
import { CustomerService } from './customer.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './technician.service';
import { TechnicianService } from './technician.service';
export const APIS = [CustomerService, DashboardService, TechnicianService];
